module.exports = __webpack_public_path__ + "img/logo.236d8ab.svg";